export default [
  {
    path: 'contact-book',
    name: 'Sổ liên lạc',
    component: () => import('@/views/account/ContactBooks.vue'),
    meta: {
      title: 'Danh sách sổ liên lạc',
      auth: true,
      permission: 'view-contactBook-list',
    },
  },
  {
    path: 'contact-book-detail/:id',
    name: 'Danh sách sổ liên lạc',
    component: () => import('@/modules/contactBook/StudentContactBookDetail.vue'),
    meta: {
      title: 'Chi tiết tin đã gửi',
      auth: true,
    },
  },
  {
    path: 'post-send',
    name: 'Gửi tin nhắn',
    component: () => import('@/views/post/PostCreate.vue'),
    meta: {
      title: 'Gửi tin nhắn',
      auth: true,
      permission: 'send-noti-immediately',
    },
  },
  {
    path: 'post-send-auto',
    name: 'Gửi tin tự động',
    component: () => import('@/views/post/PostCreateAuto.vue'),
    meta: {
      title: 'Gửi tin tự động',
      auth: true,
      permission: 'send-noti-daily',
    },
  },
  {
    path: 'post-history',
    name: 'Lịch sử gửi tin',
    component: () => import('@/views/post/PostCreateHistory.vue'),
    meta: {
      title: 'Lịch sử gửi tin',
      auth: true,
      permission: 'view-noti-history',
    },
  },
]
